import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import React from 'react'

import useMediaQuery from '../../hooks/useMediaQuery'
import style from '../../styles/components/shows/shows'
import { structure } from '../../styles/global'
import BaseCSS from '../../styles/global/BaseCSS'
import AdUnit from '../Ads/AdUnit'
import TopStories from '../HomePage/TopStories'
import Metadata from '../Metadata'
import UnresetCSS from '../UnresetCSS'
import WhereToWatch from '../WhereToWatch/WhereToWatch'
import VideoPlayer from '../utilities/VideoPlayer'

import Head from 'next/head'

const ShowsPage = ({ pageTitle, description, thumbnail, body, video, showGraphic, platforms, storyList }) => {
  const isMobileScreen = useMediaQuery(768)
  const prefix = 'News12 | '
  const hasPrefix = /^news12\s*\|\s*/i.test(pageTitle ?? '')
  return (
    <>
      <Head>
        <title>{hasPrefix ? pageTitle : `${prefix}${pageTitle}`}</title>
      </Head>
      <Metadata
        metadata={{
          title: pageTitle,
          description,
          thumbnail
        }}
      />
      <div className='shows-wrapper'>
        <div className='shows-container'>
          <div className='top-section'>
            <div className='teaser'>
              <VideoPlayer src={video?.src} type={video?.type} />
            </div>
            <div className='blurb'>
              <div className='image'>
                <img src={showGraphic?.url} alt={showGraphic?.alt} />
              </div>
              <div className='text'>{documentToReactComponents(body)}</div>
            </div>
          </div>
          {platforms?.list?.length > 0 && <WhereToWatch platforms={platforms?.list} title={platforms?.title} />}
          {storyList?.list?.length > 0 && (
            <TopStories
              isMobileScreen={isMobileScreen}
              topStories={storyList?.list}
              title={storyList?.title}
              withoutBorder
            />
          )}
        </div>
        <div className='main-layout-sidebar'>
          <div className='ads-block'>
            <AdUnit adUnitTemplate='leaderboard' id={'homePageSidebar'} type='homePageSidebar' />
            <AdUnit adUnitTemplate='rectangleVertical' id={'ad-banner-sidebar-top-1'} type='homePageSidebar' />
          </div>
        </div>
      </div>
      <style jsx>{style}</style>
      <style jsx global>
        {structure}
      </style>
      <UnresetCSS />
      <BaseCSS />
    </>
  )
}

export default ShowsPage
